export default {
	project_name: 'Grupo Boticário Training Platform',
}
